var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAniming && _vm.enable),expression:"isAniming && enable"}],staticClass:"c-donate-bubble"},[_c('div',{class:{
      'svga-player-container':true,
      'mobile': _vm.isMobile
    },attrs:{"id":"c-donate-bubble-svga-player"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }